module.exports = __webpack_public_path__ + "18a415a1fcc9a8acdc19115f5032aebc.svg";